import { Modal, Button } from "~/components/ui";

interface ResultsModalProps {
  isOpen: boolean;
  closeResultModal: () => void;
  modalContent: {
    topIcon: React.ComponentType<{ className?: string }> | string;
    header: string;
    details: string;
    actionButtonText: string;
  };
  actionButtonCallback?: () => void;
}

const ResultsModal = ({
  isOpen,
  closeResultModal,
  modalContent,
  actionButtonCallback,
}: ResultsModalProps) => {
  const renderIcon = () => {
    if (typeof modalContent.topIcon === "string") {
      // Legacy support for string URLs
      return (
        <img className="mx-auto" src={modalContent.topIcon} alt="top icon" />
      );
    } else {
      // New component-based icons
      const IconComponent = modalContent.topIcon;
      return <IconComponent className="mx-auto h-16 w-16" />;
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => closeResultModal()}
      size="md"
      footer={
        <Button onClick={actionButtonCallback || (() => closeResultModal())}>
          {modalContent.actionButtonText}
        </Button>
      }
    >
      <section>
        {renderIcon()}
        <h2 className="my-4 text-center text-2xl font-semibold">
          {modalContent.header}
        </h2>
        <div className="text-center text-lg">
          {modalContent.details.split("\n").map((string) => (
            <p key={string}>{string}</p>
          ))}
        </div>
      </section>
    </Modal>
  );
};

export default ResultsModal;
